import React, { createContext, useContext } from 'react';

import { FeatureStore, IFeatureStore } from './FeatureStore';
import { IRequesterStore, RequesterStore } from './RequesterStore';
import { IRequesterTokenStore, RequesterTokenStore } from './RequesterTokenStore';
import { ToggleStore, IToggleStore } from './ToggleStore';
import { IAuthStore, authStore } from './AuthStore';
import { UiStore, IUiStore } from './UiStore';

export class RootStore
{
  uiStore: IUiStore;
  authStore: IAuthStore;
  featureStore: IFeatureStore;
  toggleStore: IToggleStore;
  requesterStore: IRequesterStore;
  requesterTokenStore: IRequesterTokenStore;

  constructor()
  {
    this.uiStore = new UiStore();
    this.authStore = authStore;
    this.featureStore = new FeatureStore();
    this.toggleStore = new ToggleStore();
    this.requesterStore = new RequesterStore();
    this.requesterTokenStore = new RequesterTokenStore();
  }
}

let store: RootStore;
export const StoreContext = createContext<RootStore | undefined>(undefined);

export function StoreProvider({ children }: { children: React.ReactNode })
{
  const root = store ?? new RootStore();
  return <StoreContext.Provider value={root}>{children}</StoreContext.Provider>;
}

export function useStore()
{
  const context = useContext(StoreContext);
  if (context === undefined)
  {
    throw new Error("useStore must be used within StoreProvider");
  }
  return context;
}